import { useEffect, useState } from "react";
import axios from "axios";
import { Loading } from "../Other/Loading";
import { useTranslation } from "react-i18next";

const SkilSection = () => {
  const [data, setData] = useState(null);
  const { t } = useTranslation();

  
useEffect(() => {
  const fetchData = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/forbusiness`);
        //console.log("API Response:", response.data); // Log response to debug
        const events = JSON.parse(response.data);
        console.log("API Response:", events);
        setData(events.SkillSection);  // turns string into array of objects
      }
      catch (error) {
        console.error("Error fetching reasons data:", error);
      }
  };

  fetchData();
}, [t]);

  if (!data) return <div className="text-center text-gray-600"><Loading /></div>;

  return (
    <div className="p-10"  >
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center md:items-start my-12 md:my-16 space-y-6 md:space-y-0">
        {/* Left Section - Title & Description */}
        <div className="md:w-1/2">
          <h2 className="text-3xl md:text-5xl font-bold">{data.title}</h2>
          <p className="text-lg mt-2">{data.description}</p>
        </div>

        {/* Right Section - Features (2 Columns, Icon First) */}
        <div className="md:w-1/2 grid grid-cols-1 md:grid-cols-2 gap-6 mt-6 md:mt-0">
          {Array.isArray(data.features) && data.features.length > 0 ? (
            data.features.map((feature, index) => (
              <div key={index} className="text-left text-black">
                <img src={`${process.env.REACT_APP_SMIK_API_BASEURL}${feature.icon}`} alt={feature.title} className="w-12 h-12 mb-2 bg-black" />
                <h3 className="text-xl font-semibold">{feature.title}</h3>
                <p className="mt-2">{feature.description}</p>
              </div>
            ))
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default SkilSection;
